import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section id="testimonios" className="relative z-10 py-16 md:py-24 px-4 cosmic-bg" data-id="element-204">
      <div className="max-w-6xl mx-auto" data-id="element-205">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-206">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4" data-id="element-207">
            Lo que dicen las{' '}
            <span className="text-gold-gradient" data-id="element-208">astrólogas</span>
          </h2>
          <p className="text-xl text-white/80" data-id="element-209">
            Profesionales que ya transformaron su práctica
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-210">
          {/* Testimonial 1 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-2xl p-6" data-id="element-211">
            <div className="flex items-center gap-1 mb-4" data-id="element-212">
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-213" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-214" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-215" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-216" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-217" />
            </div>
            <QuoteIcon className="w-8 h-8 text-[#F5C842]/30 mb-3" data-id="element-218" />
            <p className="text-white/90 mb-6 leading-relaxed" data-id="element-219">
              "Antes me tomaba casi 4 horas armar un informe completo. Ahora lo
              hago en menos de la mitad del tiempo y mis clientas me dicen que
              se ven mucho más profesionales. ¡No puedo creer que no lo haya
              encontrado antes!"
            </p>
            <div className="flex items-center gap-3" data-id="element-220">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white font-bold" data-id="element-221">
                ML
              </div>
              <div data-id="element-222">
                <p className="text-white font-semibold" data-id="element-223">María Laura Gómez</p>
                <p className="text-white/60 text-sm" data-id="element-224">
                  Astróloga • Buenos Aires, 38 años
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-2xl p-6" data-id="element-225">
            <div className="flex items-center gap-1 mb-4" data-id="element-226">
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-227" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-228" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-229" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-230" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-231" />
            </div>
            <QuoteIcon className="w-8 h-8 text-[#F5C842]/30 mb-3" data-id="element-232" />
            <p className="text-white/90 mb-6 leading-relaxed" data-id="element-233">
              "Estaba agotada de trabajar tanto y ganar lo mismo. Con el sistema
              pude subir mis precios porque ahora mis entregas tienen otro
              nivel. Mis clientas notan la diferencia y me recomiendan más."
            </p>
            <div className="flex items-center gap-3" data-id="element-234">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white font-bold" data-id="element-235">
                CF
              </div>
              <div data-id="element-236">
                <p className="text-white font-semibold" data-id="element-237">Carolina Fernández</p>
                <p className="text-white/60 text-sm" data-id="element-238">
                  Astróloga • Córdoba, 42 años
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-2xl p-6" data-id="element-239">
            <div className="flex items-center gap-1 mb-4" data-id="element-240">
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-241" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-242" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-243" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-244" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-245" />
            </div>
            <QuoteIcon className="w-8 h-8 text-[#F5C842]/30 mb-3" data-id="element-246" />
            <p className="text-white/90 mb-6 leading-relaxed" data-id="element-247">
              "Lo que más me gustó es que no perdí mi esencia. Los informes
              siguen siendo míos, pero ahora están organizados y se ven
              increíbles. Recuperé tiempo para mi familia y para seguir
              estudiando."
            </p>
            <div className="flex items-center gap-3" data-id="element-248">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-500 to-rose-500 flex items-center justify-center text-white font-bold" data-id="element-249">
                VA
              </div>
              <div data-id="element-250">
                <p className="text-white font-semibold" data-id="element-251">Valentina Aguirre</p>
                <p className="text-white/60 text-sm" data-id="element-252">
                  Astróloga • Mendoza, 35 años
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 4 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-2xl p-6" data-id="element-253">
            <div className="flex items-center gap-1 mb-4" data-id="element-254">
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-255" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-256" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-257" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-258" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-259" />
            </div>
            <QuoteIcon className="w-8 h-8 text-[#F5C842]/30 mb-3" data-id="element-260" />
            <p className="text-white/90 mb-6 leading-relaxed" data-id="element-261">
              "Tenía miedo de que fuera algo muy técnico o difícil de usar. Pero
              es súper intuitivo. En una semana ya estaba entregando informes
              con el nuevo formato y mis clientas quedaron encantadas."
            </p>
            <div className="flex items-center gap-3" data-id="element-262">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center text-white font-bold" data-id="element-263">
                SR
              </div>
              <div data-id="element-264">
                <p className="text-white font-semibold" data-id="element-265">Sofía Rodríguez</p>
                <p className="text-white/60 text-sm" data-id="element-266">
                  Astróloga • Rosario, 29 años
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 5 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-2xl p-6 md:col-span-2 lg:col-span-1" data-id="element-267">
            <div className="flex items-center gap-1 mb-4" data-id="element-268">
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-269" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-270" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-271" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-272" />
              <StarIcon className="w-5 h-5 text-[#F5C842] fill-[#F5C842]" data-id="element-273" />
            </div>
            <QuoteIcon className="w-8 h-8 text-[#F5C842]/30 mb-3" data-id="element-274" />
            <p className="text-white/90 mb-6 leading-relaxed" data-id="element-275">
              "Llevo 15 años haciendo cartas y nunca había encontrado algo así.
              Me ayudó a profesionalizar mi trabajo sin perder la calidez que
              mis clientas valoran. Ahora puedo atender más consultas sin
              sentirme abrumada."
            </p>
            <div className="flex items-center gap-3" data-id="element-276">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center text-white font-bold" data-id="element-277">
                AM
              </div>
              <div data-id="element-278">
                <p className="text-white font-semibold" data-id="element-279">Ana María Peralta</p>
                <p className="text-white/60 text-sm" data-id="element-280">
                  Astróloga • Mar del Plata, 52 años
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}